import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess, setRenewPassword } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { UI_VERSION } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import jwt_decode from 'jwt-decode';

import getOS from 'utils/operationSystem'

function useAuth() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async ({ userName, password }) => {
        try {
			const resp = await apiSignIn({ email:userName, password: password, version: UI_VERSION, os:getOS() })
			if (resp.data.Status === 'Normal') {
				const content = resp.data.Content

				// user_must_renew_password kontrolü - şifre yenileme zorunlu ise
				// /changepassword token gerektirdiği için forgot-password akışını kullanmalıyız
				if (content.user_must_renew_password === true) {
					dispatch(setRenewPassword({
						renewPassword: true,
						regex: content.regex || null,
						lastNPassword: content.number_of_last_n_passwords || null
					}))
					// Forgot password sayfasına yönlendir (e_mail ile)
					navigate('/forgot-password', {
						state: {
							email: userName,
							renewPassword: true,
							regex: content.regex,
							lastNPassword: content.number_of_last_n_passwords
						}
					})
					return {
						status: 'renew_password',
						message: 'Şifrenizi yenilemeniz gerekmektedir. Lütfen e-posta veya SMS ile şifre sıfırlama işlemi yapın.'
					}
				}

				var decoded = jwt_decode(content);
				if(resp.data.Status) {
					dispatch(onSignInSuccess(content))
					// Danone için project_id ve project_name default olarak set ediliyor
					if(decoded.position_no<4){
						dispatch(setUser(resp.data.user || {
							avatar: '',
							userName: decoded.name_surname,
							authority: [decoded.position_name],
							positionNo: decoded.position_no,
							email: decoded.e_mail,
							permissions: [301],
							project_id: 1,
							project_name: 'Danone'
						}))
					} else if(decoded.position_no>4){
						dispatch(setUser(resp.data.user || {
							avatar: '',
							userName: decoded.name_surname,
							authority: [decoded.position_name],
							positionNo: decoded.position_no,
							email: decoded.e_mail,
							permissions: [301],
							project_id: 1,
							project_name: 'Danone'
						}))
					} else{
						dispatch(setUser(resp.data.user || {
							avatar: '',
							userName: decoded.name_surname,
							authority: [decoded.position_name],
							positionNo: decoded.position_no,
							email: decoded.e_mail,
							permissions: [300],
							project_id: 1,
							project_name: 'Danone'
						}))
					}
					const searchParams = new URLSearchParams(window.location.search)
					const redirectUrl = searchParams.get('redirectUrl')
					const loginPath = redirectUrl
						? `${appConfig.firstLoginPath}?redirectUrl=${encodeURIComponent(redirectUrl)}`
						: appConfig.firstLoginPath
					navigate(loginPath);
					return {
						status: 'success',
						message: 'Giriş yapılıyor.'
					}
				}
			} else{
				return {
                    status: 'failed',
                    message: 'Lütfen kullanıcı adı ve şifrenizi kontrol edin.'
                }
			}
		} catch (errors) {
			// 403 durumunda user_must_renew_password kontrolü
			const errorData = errors?.response?.data
			if (errorData?.Status === 'Normal' && errorData?.Content?.user_must_renew_password === true) {
				const content = errorData.Content
				dispatch(setRenewPassword({
					renewPassword: true,
					regex: content.regex || null,
					lastNPassword: content.number_of_last_n_passwords || null
				}))
				// Forgot password sayfasına yönlendir
				navigate('/forgot-password', {
					state: {
						email: userName,
						renewPassword: true,
						regex: content.regex,
						lastNPassword: content.number_of_last_n_passwords
					}
				})
				return {
					status: 'renew_password',
					message: 'Şifrenizi yenilemeniz gerekmektedir. Lütfen e-posta veya SMS ile şifre sıfırlama işlemi yapın.'
				}
			}
			return {
                status: 'failed',
                message: errors?.response?.data?.error || errors.toString()
            }
		}
    }

    const handleSignOut = ()  => {
		dispatch(onSignOutSuccess())
		dispatch(setUser(initialState))
		navigate(appConfig.unAuthenticatedEntryPath)
	}

    const signOut = async () => {
		try {
			await apiSignOut()
			handleSignOut()
		} catch (errors) {
			handleSignOut()
		}
	}
    
    return {
        authenticated: token && signedIn,
        signIn,
        signOut
    }
}

export default useAuth